import { getUID } from '@redviking/argonaut-util/src/getUID';
import { getAppletEvents } from '@redviking/argonaut-util/src/mes/get-applet-events';
import type { NodeSpec } from './NodeSpec';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { defineControlOpts } from '../../controls/FlowNodeControl';
import { defaultControlUpdateValueHandler } from '@redviking/argonaut-core-ui/src/applet/design/flows/controls/control-event-handler';

export const appletEventEmitUiNodeSpec: NodeSpec<NodeCfg<'appletEventEmit'>> = {
    requiredSockets: [ 'trigger' ],
    cfg: () => ({ controlValues: { appletEventId: '' }, id: getUID(), kind: 'appletEventEmit', disabled: false, width: 200 }),
    controls: (nodeCfg) => ({
        appletEventId: defineControlOpts({
            cfg: {
                kind: 'selectEvent',
                label: 'Event',
            },
            on: { 'update:value': defaultControlUpdateValueHandler },
            value: nodeCfg.controlValues.appletEventId,
        }),
    }),
    inputs: () => ({
        trigger: { socket: 'event', label: 'Trigger' },
    }),
    kindLabel: 'Emit Applet Event',
    nodeCategory: 'events',
    outputs: () => ({ next: { socket: 'event', label: 'Next' } }),
    validator: (node, appletDesignVersionConfig) => {
        const events = getAppletEvents(appletDesignVersionConfig);
        const validEventNames = Object.keys(events);
        const errors: Record<string, string> = {};
        if (!node.controlValues.appletEventId) {
            errors.appletEventId = 'Event ID is required';
        }
        if (!validEventNames.includes(node.controlValues.appletEventId)) {
            errors.appletEventId = 'Event ID is not a valid event';
        }
        return Object.keys(errors).length ? errors : true;
    },
};
